import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../../../components/formatters/numberFormatter';




const LoadPurchaseJv = (props) => {

    const { setTransactions, journalVoucher, cart, totalDiscounts, netTotal, vat, selectedCurrency, subTotal } = props;

    const { api, userData, settingData, mainCurrency, rateFromToCurrency,
        rateMainToSecondaryCurrency, rateToMainCurrency, productData } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;



    // load Transactions
    useEffect(() => {
        loadJV();
    }, [journalVoucher, cart]);

    const accountId = journalVoucher?.accountId;
    const warehouseId = journalVoucher?.warehouseId;
    const cashAccountId = userRole.cashAccountId;
    const isDebit = journalVoucher.isDebit;

    const downPayment = journalVoucher.downPayment;

    const rate = selectedCurrency?.rate;
    const currencyId = selectedCurrency?.id;

    const purchaseAccountId = settingData?.purchaseAccountId;

    const vatPurchaseAccountId = settingData.vatPurchaseAccountId;
    const purchaseDiscountAccountId = settingData.purchaseDiscountAccountId;
    const purchaseChargesAccountId = settingData.purchaseChargesAccountId;


    const loadJV = () => {

        let updatedTransactions = [];


        // purchase
        updatedTransactions = loadPurchaseTansaction(updatedTransactions, isDebit);

        // vat
        if (vat != 0) {
            updatedTransactions = loadAcountTransaction(updatedTransactions, isDebit, vatPurchaseAccountId, 'VAT', vat);
        }

        // discount
        if (totalDiscounts != 0) {
            updatedTransactions = loadAcountTransaction(updatedTransactions, !isDebit, purchaseDiscountAccountId, 'Discount', totalDiscounts);
        }

        // supplier
        if (journalVoucher.accountId) {
            updatedTransactions = loadAcountTransaction(updatedTransactions, !isDebit, accountId, 'Supplier', netTotal);
        }

        // cash
        if (journalVoucher.paymentType == 'cash') {
            if (journalVoucher.accountId) {
                updatedTransactions = loadAcountTransaction(updatedTransactions, isDebit, accountId, 'Supplier', netTotal);
            }
            updatedTransactions = loadAcountTransaction(updatedTransactions, !isDebit, cashAccountId, 'Cash', netTotal);
        }
        else if (journalVoucher.downPayment > 0) {
            updatedTransactions = loadAcountTransaction(updatedTransactions, isDebit, accountId, 'Supplier', downPayment);
            updatedTransactions = loadAcountTransaction(updatedTransactions, !isDebit, cashAccountId, 'Cash', downPayment);
        }

        setTransactions(updatedTransactions)

    }


    //  Sale sRevenue
    const loadPurchaseTansaction = (updatedTransactions, isDebit) => {

        const debit = isDebit ? subTotal : 0;
        const credit = !isDebit ? subTotal : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const cartTransaction = {
            type: 'Purchase',
            accountId: purchaseAccountId,
            isDebit: isDebit,
            details: '',
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            rate: rate,
            warehouseId: warehouseId,
            currencyId: currencyId,
            haveCart: true,
        }

        updatedTransactions.push(cartTransaction);
        return updatedTransactions;
    };


    const loadAcountTransaction = (updatedTransactions, isDebit, accountId, type, total) => {


        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const accountTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
        }

        updatedTransactions.push(accountTransaction);

        return updatedTransactions;
    }

    return (


        <></>

    )
}


export default LoadPurchaseJv;